export default __webpack_public_path__ + "static/media/Planning Box2Home2.317041ef.svg";